export {View as CardIOView} from 'react-native';
export const CardIOUtilities = {
  preload: function () {},
  CAN_READ_CARD_WITH_CAMERA: false,
};
